/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import ReactTooltip from 'react-tooltip';
import {Glyphicon} from 'react-bootstrap';
import DynamicDropDownMenu from './DynamicDropDownMenu';
import '../../../styles/establishment/NaicsDropdown.css';

const NaicsSearchBox = ({
  name,
  label,
  lookUpNaics,
  onBlur,
  placeholder,
  value,
  error,
  contextHelp,
  tooltip,
  hideDropDown,
  onSelect,
  NAICSOptions,
  naicsLoading
}) => {

  let wrapperClass = 'form-group';
  contextHelp = "<p><i>Begin typing either your NAICS code or the industry description, then select the correct value from the list. If you don't know your code and can't find it in the list, you can look it up at <a href='http://www.census.gov/naics' title='North American Industry Classification System' target ='_blank'>census.gov</a>.</i></p>";
  if (error && error.length > 0) {
    wrapperClass += " has-error";
  }
  return (
    <div className="question-part" key="naics-search-box-container" onBlur={onBlur}>
      <fieldset className="naics-search-box">
        <div className={wrapperClass}>
          <legend>
            <label htmlFor={name}>
              {label}
              <span>
                <Glyphicon glyph="info-sign" className="span-tooltip" data-tip data-for={name}/>
                <ReactTooltip id={name} place="right" type="dark" effect="float">
                  <div
                    dangerouslySetInnerHTML={{
                    __html: tooltip
                  }}/>
                </ReactTooltip>
              </span>
            </label>
          </legend>
          <div className="field">
            <input
              type="text"
              name={name}
              id="naics"
              className={!hideDropDown ? "form-control input-border naics-input dropdown-shown"
              : "form-control input-border naics-input"}
              placeholder={placeholder}
              value={value}
              autoComplete="off"
              onChange={lookUpNaics}
              onFocus={lookUpNaics}
              maxLength={300}/>
          </div>
          <div className="dynamic-dropdown-container" onBlur={onBlur}>
            <DynamicDropDownMenu
              hideDropDown={hideDropDown}
              onSelect={onSelect}
              NAICSOptions={NAICSOptions}
              naicsLoading={naicsLoading}/>
          </div>
          {error && <div tabIndex="0" className="error-message">{error}</div>}
          <div
            className="context-help"
            dangerouslySetInnerHTML={{
            __html: contextHelp
          }}/>
        </div>
      </fieldset>
    </div>
  );

};

NaicsSearchBox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  lookUpNaics: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  hideDropDown: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  naicsLoading: PropTypes.bool.isRequired,
  NAICSOptions: PropTypes.array,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  contextHelp: PropTypes.string,
  tooltip: PropTypes.string,
  ref: PropTypes.object
};

export default NaicsSearchBox;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/NAICS/NaicsSearchBox.js
 **/